/* LAYOUT */
export const LOADER_START = 'CHANGE_LAYOUT';
export const LOADER_STOP = 'CHANGE_LAYOUT_WIDTH';
export const CHANGE_THEME = 'CHANGE_THEME';
export const ALL_CITY = 'ALL_CITY';
export const GET_SUPPLIER = 'GET_SUPPLIER';
export const COMMON_ERROR = 'COMMON_ERROR';
